import React, { memo } from "react";
import { getConfiguredString } from "../helper-methods/configureString";

const ConfigureString = ({ keyString }) => {
  return <>{getConfiguredString(keyString)}</>;
};

export default memo(ConfigureString);
